import React from "react";
import {
  GlobalButton,
  GlobalTextAreaField,
  GlobalTextField,
} from "../../../../global/forms/GlobalFormFields";
import GlobalFormShell from "../../../../global/forms/GlobalFormShell";
import { useRoleSectionContext } from "../RoleSectionContext";

function IconShield(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.65"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="ub-icon-svg"
      aria-hidden
      {...props}
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  );
}

export default function RoleCreationSection() {
  const {
    form,
    setField,
    submit,
    resetForm,
    isEdit,
    busy,
    showFormAlert,
    formAlertRef,
    fieldErrors,
    submitError,
  } = useRoleSectionContext();

  const hasFieldErrors = Object.values(fieldErrors).some(Boolean);

  return (
    <div id="ub-roles-create">
      <header className="ub-section__head">
        <div className="ub-section__icon-wrap ub-section__icon-wrap--roles" aria-hidden>
          <IconShield />
        </div>
        <div className="ub-section__head-text">
          <h2 id="roles-heading" className="ub-section__title">
            Roles
          </h2>
          <p className="ub-section__lead">
            Create roles for staff accounts. The directory lists active roles only;
            removing a role soft-deletes it (does not permanently delete).
          </p>
        </div>
      </header>

      <GlobalFormShell
        legend={isEdit ? "Edit role" : "Add role"}
        showAlert={showFormAlert}
        alertText={
          submitError || (hasFieldErrors ? "Please fix the fields below." : "")
        }
        alertId="role-form-alert"
        formAlertRef={formAlertRef}
        actions={
          <>
            {isEdit ? (
              <GlobalButton disabled={busy} variant="ghost" onClick={resetForm}>
                Cancel edit
              </GlobalButton>
            ) : null}
            <GlobalButton
              disabled={busy}
              variant="primary"
              type="button"
              onClick={() => submit()}
            >
              {isEdit ? "Save role" : "Create role"}
            </GlobalButton>
          </>
        }
      >
        <GlobalTextField
          id="role-name"
          label="Role name"
          value={form.role_name}
          onChange={(v) => setField("role_name", v)}
          error={fieldErrors.role_name}
          baseAlertId={showFormAlert ? "role-form-alert" : undefined}
        />
        <GlobalTextAreaField
          id="role-description"
          label="Description"
          value={form.description}
          onChange={(v) => setField("description", v)}
          rows={2}
        />
      </GlobalFormShell>
    </div>
  );
}
